<template>
  <div class="flex flex-col h-full w-full">
    <h2 class="font-extrabold">{{ product.part.nkrCode }}</h2>
    <h3>{{ productTitle }}</h3>
    <div
      v-if="productImageUrl"
      class="w-full h-full product-image-box"
      :style="{ 'background-image': `url(${productImageUrl})` }"
    ></div>
  </div>
</template>
<script>
export default {
  name: "ProductListItem",
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  computed: {
    productImageUrl() {
      let mainImage = this.product.images.find(image => image.main == 1);
      if (mainImage) {
        return mainImage.imageRoute;
      }

      if (this.product.images.length > 0) {
        return this.product.images[0].imageRoute;
      }

      return null;
    },
    productTitle() {
      if (this.product.part.title && this.product.part.title != "") {
        return this.product.part.title;
      }
      return this.product.part.description ?? "";
    }
  }
};
</script>
<style lang="postcss" scoped>
.product-image-box {
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
}
</style>
